export default {
  header: 'Quick Access',
  renewal: {
    header: 'Quick Renewal'
  }
}



// WEBPACK FOOTER //
// ./src/Quick/langs/en_us/index.js